import {variationsRes} from "../interface/variable.interface";

export const dataVar: variationsRes = {
    "items": [
        {
            "sku": "20630550020",
            "supplier": "Fruits",
            "supplierId": 143,
            "category": null,
            "id": 19931,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Olma",
            "supplierId": 143,
            "category": null,
            "id": 19911,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Nok",
            "supplierId": 143,
            "category": null,
            "id": 19932,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Banan",
            "supplierId": 143,
            "category": null,
            "id": 19933,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Anor",
            "supplierId": 143,
            "category": null,
            "id": 19934,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Qulupnay",
            "supplierId": 143,
            "category": null,
            "id": 19935,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Olxo'ri",
            "supplierId": 143,
            "category": null,
            "id": 19936,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Apelsin",
            "supplierId": 143,
            "category": null,
            "id": 19937,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Mandarin",
            "supplierId": 143,
            "category": null,
            "id": 19938,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Lola",
            "supplierId": 143,
            "category": null,
            "id": 19939,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Atirgul",
            "supplierId": 143,
            "category": null,
            "id": 19920,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Pion",
            "supplierId": 143,
            "category": null,
            "id": 19921,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "flowers",
            "supplierId": 143,
            "category": null,
            "id": 19922,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Nimadir",
            "supplierId": 143,
            "category": null,
            "id": 19923,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Passion",
            "supplierId": 143,
            "category": null,
            "id": 19924,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        },
        {
            "sku": "20630550020",
            "supplier": "Fruits",
            "supplierId": 143,
            "category": null,
            "id": 19925,
            "barcode": "776288670944",
            "lastUpdateTime": "2019-10-10 15:11:58",
            "showMarket": true,
            "uploadedImages": [],
            "innerHitIds": null,
            "technicalCard": false,
            "importProperties": []
        }
    ],
    "page": 1,
    "total_count": 35169
}